import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import s from "../assets/styles/Admin.module.css";
import root from "../assets/styles/Root.module.css";

function isoToLocalInput(iso) {
   if (!iso) return "";
   const d = new Date(iso);
   const pad = (n) => String(n).padStart(2, "0");
   const yyyy = d.getFullYear();
   const mm = pad(d.getMonth() + 1);
   const dd = pad(d.getDate());
   const hh = pad(d.getHours());
   const mi = pad(d.getMinutes());
   return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
}

function PrizeRow({ idx, value, onChange, onRemove, availablePrizes }) {
   return (
      <div className={s.formRow}>
         <div className={s.field}>
            <label>Приз</label>
            <select
               value={value.prize_id || ""}
               onChange={e => {
                  const selectedPrize = availablePrizes.find(p => p.id == e.target.value);
                  onChange(idx, {
                     ...value,
                     prize_id: e.target.value,
                     prize_name: selectedPrize?.name || ""
                  });
               }}
            >
               <option value="">Выберите приз</option>
               {availablePrizes.map(prize => (
                  <option key={prize.id} value={prize.id}>
                     {prize.name}
                  </option>
               ))}
            </select>
         </div>
         <div className={s.field}>
            <label>Мин. сумма, $</label>
            <input
               type="number"
               step="0.01"
               value={value.amount_min_usd}
               onChange={e => onChange(idx, { ...value, amount_min_usd: e.target.value })}
            />
         </div>
         <div className={s.field}>
            <label>Макс. сумма, $</label>
            <input
               type="number"
               step="0.01"
               value={value.amount_max_usd}
               onChange={e => onChange(idx, { ...value, amount_max_usd: e.target.value })}
            />
         </div>
         <div className={s.field}>
            <label>Вес (вероятность)</label>
            <input
               type="number"
               value={value.weight}
               onChange={e => onChange(idx, { ...value, weight: e.target.value })}
            />
         </div>
         <div className={s.field}>
            <label>&nbsp;</label>
            <button type="button" className={root.btn} onClick={() => onRemove(idx)}>Удалить</button>
         </div>
      </div>
   );
}

function BonusPrizeRow({ idx, value, onChange, onRemove, availablePrizes }) {
   return (
      <div className={s.formRow}>
         <div className={s.field}>
            <label>Тип бонуса</label>
            <select
               value={value.bonus_type || ""}
               onChange={e => {
                  onChange(idx, {
                     ...value,
                     bonus_type: e.target.value,
                     multiplier: e.target.value === "multiplier" ? (value.multiplier || 2) : null,
                     prize_id: e.target.value === "prize" ? (value.prize_id || "") : null,
                     amount_min_usd: e.target.value === "prize" ? (value.amount_min_usd || 0.01) : null,
                     amount_max_usd: e.target.value === "prize" ? (value.amount_max_usd || 1.00) : null,
                  });
               }}
            >
               <option value="">Выберите тип</option>
               <option value="multiplier">Умножение выигрыша</option>
               <option value="prize">Обычный приз</option>
            </select>
         </div>
         
         {value.bonus_type === "multiplier" && (
            <div className={s.field}>
               <label>Множитель (x2, x3...)</label>
               <input
                  type="number"
                  min="2"
                  value={value.multiplier || 2}
                  onChange={e => onChange(idx, { ...value, multiplier: Number(e.target.value) })}
               />
            </div>
         )}
         
         {value.bonus_type === "prize" && (
            <>
               <div className={s.field}>
                  <label>Приз</label>
                  <select
                     value={value.prize_id || ""}
                     onChange={e => onChange(idx, { ...value, prize_id: e.target.value })}
                  >
                     <option value="">Выберите приз</option>
                     {availablePrizes.map(prize => (
                        <option key={prize.id} value={prize.id}>
                           {prize.name}
                        </option>
                     ))}
                  </select>
               </div>
               <div className={s.field}>
                  <label>Мин. сумма, $</label>
                  <input
                     type="number"
                     step="0.01"
                     value={value.amount_min_usd || 0.01}
                     onChange={e => onChange(idx, { ...value, amount_min_usd: e.target.value })}
                  />
               </div>
               <div className={s.field}>
                  <label>Макс. сумма, $</label>
                  <input
                     type="number"
                     step="0.01"
                     value={value.amount_max_usd || 1.00}
                     onChange={e => onChange(idx, { ...value, amount_max_usd: e.target.value })}
                  />
               </div>
            </>
         )}
         
         <div className={s.field}>
            <label>Вес (вероятность)</label>
            <input
               type="number"
               min="1"
               value={value.weight || 1}
               onChange={e => onChange(idx, { ...value, weight: Number(e.target.value) })}
            />
         </div>
         
         <div className={s.field}>
            <label>&nbsp;</label>
            <button type="button" className={root.btn} onClick={() => onRemove(idx)}>Удалить</button>
         </div>
      </div>
   );
}

export default function CaseEditPage() {
   const { id } = useParams();
   const nav = useNavigate();
   const { authFetch } = useAuth();

   const [loading, setLoading] = useState(true);
   const [types, setTypes] = useState([]);
   const [availablePrizes, setAvailablePrizes] = useState([]);
   const [caseData, setCaseData] = useState(null);

   const [name, setName] = useState("");
   const [price, setPrice] = useState(0);
   const [typeId, setTypeId] = useState("");
   const [availableFrom, setAvailableFrom] = useState("");
   const [availableTo, setAvailableTo] = useState("");
   const [spinsTotal, setSpinsTotal] = useState(0);
   const [isActive, setIsActive] = useState(true);
   const [prizes, setPrizes] = useState([]);
   
   // Бонусная система
   const [isBonusEnabled, setIsBonusEnabled] = useState(false);
   const [bonusTriggerType, setBonusTriggerType] = useState("");
   const [bonusChance, setBonusChance] = useState(0);
   const [bonusEveryNOpens, setBonusEveryNOpens] = useState(10);
   const [bonusPrizes, setBonusPrizes] = useState([]);

   // avatar state
   const [avatarFile, setAvatarFile] = useState(null);
   const [avatarPreview, setAvatarPreview] = useState("");
   const fileInputRef = useRef(null);
   const objectUrlRef = useRef(null);

   // Табы
   const [activeTab, setActiveTab] = useState("main");
   const tabRefs = useRef({});
   const indicatorRef = useRef(null);
   const tabsContainerRef = useRef(null);

   const [error, setError] = useState("");
   const [ok, setOk] = useState("");

   useEffect(() => {
      let mounted = true;
      (async () => {
         try {
            const [resCase, resTypes, resPrizes] = await Promise.all([
               authFetch(`/api/admin/cases/${id}/`),
               authFetch(`/api/cases/types/`),
               authFetch(`/api/cases/prizes/`),
            ]);
            const dataCase = await resCase.json();
            const dataTypes = await resTypes.json();
            const dataPrizes = await resPrizes.json();
            
            if (!mounted) return;
            
            setCaseData(dataCase);
            setTypes(Array.isArray(dataTypes) ? dataTypes : []);
            setAvailablePrizes(Array.isArray(dataPrizes) ? dataPrizes.filter(p => p.is_active) : []);
            
            setName(dataCase.name || "");
            setPrice(dataCase.price_usd || 0);
            setTypeId(dataCase.type?.id ? String(dataCase.type.id) : (dataCase.type_id != null ? String(dataCase.type_id) : ""));
            setAvailableFrom(isoToLocalInput(dataCase.available_from));
            setAvailableTo(isoToLocalInput(dataCase.available_to));
            setSpinsTotal(dataCase.spins_total || 0);
            setIsActive(Boolean(dataCase.is_active));
            
            // Обрабатываем призы - поддерживаем старый и новый формат
            const prizesList = dataCase.prizes || [];
            setPrizes(prizesList.map(p => ({
               id: p.id,
               prize_id: p.prize?.id || p.prize_id || "",
               prize_name: p.prize?.name || "",
               amount_min_usd: p.amount_min_usd || p.amount_usd || 0.01,
               amount_max_usd: p.amount_max_usd || p.amount_usd || 1.00,
               weight: p.weight || 1,
            })));
            
            // Бонусная система - новая структура
            setIsBonusEnabled(Boolean(dataCase.is_bonus_enabled));
            setBonusTriggerType(dataCase.bonus_trigger_type || "");
            setBonusChance(dataCase.bonus_chance || 0);
            setBonusEveryNOpens(dataCase.bonus_every_n_opens || 10);
            
            // Обрабатываем bonus_prizes (JSONField)
            const bonusPrizesList = dataCase.bonus_prizes || [];
            if (Array.isArray(bonusPrizesList) && bonusPrizesList.length > 0) {
               setBonusPrizes(bonusPrizesList.map(bp => ({
                  bonus_type: bp.bonus_type || "",
                  multiplier: bp.multiplier || null,
                  prize_id: bp.prize_id || null,
                  amount_min_usd: bp.amount_min_usd || 0.01,
                  amount_max_usd: bp.amount_max_usd || 1.00,
                  weight: bp.weight || 1,
               })));
            } else {
               setBonusPrizes([]);
            }

            // выставляем предпросмотр текущего аватара, если он есть
            setAvatarPreview(dataCase.avatar_url || "");
            setLoading(false);
         } catch (e) {
            if (mounted) {
               setError("Ошибка загрузки данных");
               setLoading(false);
            }
         }
      })();
      return () => { mounted = false; };
   }, [authFetch, id]);

   useEffect(() => {
      // cleanup ObjectURL при размонтировании
      return () => {
         if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
      };
   }, []);

   useEffect(() => {
      // Обновление позиции индикатора при смене таба
      const updateIndicator = () => {
         const activeTabElement = tabRefs.current[activeTab];
         const indicator = indicatorRef.current;
         const container = tabsContainerRef.current;

         if (activeTabElement && indicator && container) {
            const containerRect = container.getBoundingClientRect();
            const tabRect = activeTabElement.getBoundingClientRect();
            
            indicator.style.left = `${tabRect.left - containerRect.left}px`;
            indicator.style.width = `${tabRect.width}px`;
         }
      };

      // Обновляем через requestAnimationFrame для корректного рендера
      const rafId = requestAnimationFrame(() => {
         updateIndicator();
         // Дополнительный вызов через небольшую задержку для надежности
         setTimeout(updateIndicator, 0);
      });

      // Обновляем при изменении размера окна
      window.addEventListener('resize', updateIndicator);
      
      return () => {
         cancelAnimationFrame(rafId);
         window.removeEventListener('resize', updateIndicator);
      };
   }, [activeTab]);

   const onAvatarChange = (e) => {
      const file = e.target.files?.[0];
      if (!file) {
         setAvatarFile(null);
         // если убрать предпросмотр — покажем оригинальный avatar_url из caseData
         setAvatarPreview(caseData?.avatar_url || "");
         return;
      }
      // базовая валидация
      const name = (file.name || "").toLowerCase();
      const isImage = file.type?.startsWith("image/") || name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png");
      const maxSizeMB = 10; // лимит 10 МБ (как на бэке)
      if (!isImage) {
         setError("Разрешены только изображения (JPG/PNG)");
         if (fileInputRef.current) fileInputRef.current.value = "";
         return;
      }
      if (file.size > maxSizeMB * 1024 * 1024) {
         setError(`Размер изображения не должен превышать ${maxSizeMB} МБ`);
         if (fileInputRef.current) fileInputRef.current.value = "";
         return;
      }
      setError("");
      setAvatarFile(file);
      // предпросмотр выбранного файла
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
      const url = URL.createObjectURL(file);
      objectUrlRef.current = url;
      setAvatarPreview(url);
   };

   const clearChosenAvatar = () => {
      setAvatarFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setAvatarPreview(caseData?.avatar_url || "");
      if (objectUrlRef.current) {
         URL.revokeObjectURL(objectUrlRef.current);
         objectUrlRef.current = null;
      }
   };

   const addPrize = () => setPrizes(p => [...p, { prize_id: "", amount_min_usd: 0.01, amount_max_usd: 1.00, weight: 1 }]);
   const setPrize = (idx, v) => setPrizes(p => p.map((x, i) => i === idx ? v : x));
   const removePrize = (idx) => setPrizes(p => p.filter((_, i) => i !== idx));

   const onSubmit = async (e) => {
      e.preventDefault();
      setError("");
      setOk("");
   
      try {
         const toIsoOrNull = (v) => (v ? new Date(v).toISOString() : "");
     
         const fd = new FormData();
         fd.append("name", String(name));
         fd.append("price_usd", String(Number(price)));
         fd.append("is_active", isActive ? "true" : "false");
         fd.append("type_id", String(typeId));
         if (availableFrom) fd.append("available_from", toIsoOrNull(availableFrom));
         if (availableTo) fd.append("available_to", toIsoOrNull(availableTo));
         fd.append("spins_total", String(Number(spinsTotal || 0)));
         
         // Бонусная система
         fd.append("is_bonus_enabled", String(isBonusEnabled));
         if (isBonusEnabled) {
            if (bonusTriggerType) {
               fd.append("bonus_trigger_type", bonusTriggerType);
            }
            if (bonusTriggerType === "random") {
               const bonusChanceValue = bonusChance !== null && bonusChance !== undefined && bonusChance !== "" 
                  ? String(Number(bonusChance)) 
                  : "0";
               fd.append("bonus_chance", bonusChanceValue);
            }
            if (bonusTriggerType === "every_n_opens") {
               const bonusEveryNOpensValue = bonusEveryNOpens !== null && bonusEveryNOpens !== undefined && bonusEveryNOpens !== "" 
                  ? String(Number(bonusEveryNOpens)) 
                  : "10";
               fd.append("bonus_every_n_opens", bonusEveryNOpensValue);
            }
            // Отправляем бонусные призы
            fd.append("bonus_prizes", JSON.stringify(
               bonusPrizes.map(bp => {
                  const item = {
                     bonus_type: bp.bonus_type,
                     weight: Number(bp.weight || 1),
                  };
                  if (bp.bonus_type === "multiplier") {
                     item.multiplier = Number(bp.multiplier || 2);
                  } else if (bp.bonus_type === "prize") {
                     item.prize_id = Number(bp.prize_id);
                     item.amount_min_usd = Number(bp.amount_min_usd || 0.01);
                     item.amount_max_usd = Number(bp.amount_max_usd || 1.00);
                  }
                  return item;
               })
            ));
         }
     
         fd.append(
            "prizes",
            JSON.stringify(
               (prizes || []).map((p) => ({
                  ...(p.id ? { id: p.id } : {}),
                  prize_id: Number(p.prize_id),
                  amount_min_usd: Number(p.amount_min_usd),
                  amount_max_usd: Number(p.amount_max_usd),
                  weight: Number(p.weight || 1),
               }))
            )
         );
     
         if (avatarFile) {
            fd.append("avatar", avatarFile, avatarFile.name);
         }
     
         const res = await authFetch(`/api/admin/cases/${id}/`, {
            method: "PUT",
            body: fd,
         });
     
         if (!res.ok) {
            let msg = "Ошибка";
            try {
               const err = await res.json();
               if (err?.detail) msg = err.detail;
               else if (err && typeof err === "object") {
                  msg = Object.entries(err)
                     .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
                     .join("; ");
               }
            } catch {}
            throw new Error(msg);
         }
     
         const updated = await res.json().catch(() => null);
     
         // Если бэкенд вернул новый URL — сразу показываем его (с bust-квери),
         // и только после этого освобождаем objectURL.
         if (updated?.avatar_url) {
            const bust =
               updated.avatar_url +
               (updated.avatar_url.includes("?") ? "&" : "?") +
               "v=" +
               Date.now();
     
            setAvatarPreview(bust);
            setCaseData((prev) =>
               prev ? { ...prev, avatar_url: bust } : { avatar_url: bust }
            );
     
            // теперь можно безопасно освободить объект-URL
            if (objectUrlRef.current) {
               URL.revokeObjectURL(objectUrlRef.current);
               objectUrlRef.current = null;
            }
         }
     
         // инпут сбрасываем, но preview НЕ трогаем
         setAvatarFile(null);
         if (fileInputRef.current) fileInputRef.current.value = "";
     
         setOk("Сохранено");
      } catch (err) {
         setError(err.message || "Ошибка");
      }
   };

   const onDelete = async () => {
      if (!window.confirm("Удалить кейс? Действие необратимо.")) return;
      const res = await authFetch(`/api/admin/cases/${id}/`, { method: "DELETE" });
      if (res.ok) nav("/cases", { replace: true });
   };

   if (loading) return <div className={s.page}><div className={s.card}>Загрузка...</div></div>;

   return (
      <div className={s.page}>
         <div className={s.header}>
            <h2 className={s.title}>Редактирование кейса #{caseData?.id}</h2>
            <div className={s.actions}>
               <button className={root.btn} onClick={() => nav("/cases")}>Назад</button>
               <button className={root.btn} onClick={onDelete}>Удалить</button>
            </div>
         </div>

         {/* Табы */}
         <div ref={tabsContainerRef} className={s.tabs}>
            <button
               ref={el => tabRefs.current.main = el}
               type="button"
               className={`${s.tab} ${activeTab === "main" ? s.tabActive : ""}`}
               onClick={() => setActiveTab("main")}
            >
               Главная
            </button>
            <button
               ref={el => tabRefs.current.bonus = el}
               type="button"
               className={`${s.tab} ${activeTab === "bonus" ? s.tabActive : ""}`}
               onClick={() => setActiveTab("bonus")}
            >
               Бонусная система
            </button>
            <div ref={indicatorRef} className={s.tabIndicator} />
         </div>

         <div className={`${s.card} ${s.cardNarrow}`}>
            <form onSubmit={onSubmit} className={s.formCompact}>
               {activeTab === "main" && (
                  <>
                     <div className={s.cols2}>
                        <div className={s.field}>
                           <label>Название</label>
                           <input value={name} onChange={e => setName(e.target.value)} required />
                        </div>

                        <div className={s.field}>
                           <label>Цена, $</label>
                           <input type="number" value={price} onChange={e => setPrice(e.target.value)} required />
                        </div>

                        <div className={s.field}>
                           <label>Тип кейса</label>
                           <select value={typeId} onChange={e => setTypeId(e.target.value)} required>
                              <option value="">Выберите тип</option>
                              {types.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                           </select>
                        </div>

                        <div className={s.field}>
                           <label>Открыт с</label>
                           <input type="datetime-local" value={availableFrom} onChange={e => setAvailableFrom(e.target.value)} />
                        </div>

                        <div className={s.field}>
                           <label>Открыт до</label>
                           <input type="datetime-local" value={availableTo} onChange={e => setAvailableTo(e.target.value)} />
                        </div>

                        <div className={s.field}>
                           <label>Лимит круток</label>
                           <input type="number" value={spinsTotal} onChange={e => setSpinsTotal(e.target.value)} />
                        </div>

                        <div className={s.field}>
                           <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <input
                                 type="checkbox"
                                 checked={isActive}
                                 onChange={e => setIsActive(e.target.checked)}
                              />
                              Активен
                           </label>
                        </div>
                     </div>

                     <div className={s.cols2}>
                        {/* Аватар */}
                        <div className={s.field}>
                           <label>Аватар кейса</label>
                           <input
                              ref={fileInputRef}
                              type="file"
                              accept="image/*"
                              onChange={onAvatarChange}
                           />
                           {avatarPreview && (
                              <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 12 }}>
                                 <img
                                    src={avatarPreview}
                                    alt="preview"
                                    width={72}
                                    height={72}
                                    style={{ objectFit: "cover", borderRadius: 8, border: "1px solid #e5e5e5" }}
                                 />
                                 {avatarFile && (
                                    <button type="button" className={root.btn} onClick={clearChosenAvatar}>
                                       Отменить выбор
                                    </button>
                                 )}
                              </div>
                           )}
                           <div className={s.hint}>Поддерживаются изображения до 10 МБ.</div>
                        </div>
                     </div>

                     <div className={s.field}>
                        <label>Призы</label>
                        {prizes.map((p, idx) => (
                           <PrizeRow
                              key={idx}
                              idx={idx}
                              value={p}
                              onChange={setPrize}
                              onRemove={removePrize}
                              availablePrizes={availablePrizes}
                           />
                        ))}
                        <button type="button" className={root.btn} onClick={addPrize}>Добавить приз</button>
                     </div>
                  </>
               )}

               {activeTab === "bonus" && (
                  <div>
                     <div className={s.field}>
                        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                           <input
                              type="checkbox"
                              checked={isBonusEnabled}
                              onChange={e => setIsBonusEnabled(e.target.checked)}
                           />
                           Включить бонусную систему
                        </label>
                     </div>

                     {isBonusEnabled && (
                        <>
                           <div className={s.cols2}>
                              <div className={s.field}>
                                 <label>Условие выпадения бонуса</label>
                                 <select
                                    value={bonusTriggerType}
                                    onChange={e => setBonusTriggerType(e.target.value)}
                                 >
                                    <option value="">Выберите условие</option>
                                    <option value="random">Случайное выпадение</option>
                                    <option value="every_n_opens">Каждое N-ое открытие</option>
                                 </select>
                                 <div className={s.hint}>Тип условия для выпадения бонуса</div>
                              </div>

                              {bonusTriggerType === "random" && (
                                 <div className={s.field}>
                                    <label>Шанс бонуса (0-1)</label>
                                    <input
                                       type="number"
                                       step="0.0001"
                                       min="0"
                                       max="1"
                                       value={bonusChance}
                                       onChange={e => setBonusChance(e.target.value)}
                                    />
                                    <div className={s.hint}>Вероятность выпадения бонуса</div>
                                 </div>
                              )}

                              {bonusTriggerType === "every_n_opens" && (
                                 <div className={s.field}>
                                    <label>Каждое N-ое открытие</label>
                                    <input
                                       type="number"
                                       min="1"
                                       value={bonusEveryNOpens}
                                       onChange={e => setBonusEveryNOpens(e.target.value)}
                                    />
                                    <div className={s.hint}>Бонус будет выпадать каждое N-ое открытие без бонуса (например, каждое 10-ое)</div>
                                 </div>
                              )}
                           </div>

                           <div className={s.field}>
                              <label>Бонусные призы</label>
                              {bonusPrizes.map((bp, idx) => (
                                 <BonusPrizeRow
                                    key={idx}
                                    idx={idx}
                                    value={bp}
                                    onChange={(idx, val) => {
                                       const newPrizes = [...bonusPrizes];
                                       newPrizes[idx] = val;
                                       setBonusPrizes(newPrizes);
                                    }}
                                    onRemove={(idx) => setBonusPrizes(bonusPrizes.filter((_, i) => i !== idx))}
                                    availablePrizes={availablePrizes}
                                 />
                              ))}
                              <button
                                 type="button"
                                 className={root.btn}
                                 onClick={() => setBonusPrizes([...bonusPrizes, { bonus_type: "", weight: 1 }])}
                              >
                                 Добавить бонусный приз
                              </button>
                              <div className={s.hint}>
                                 Добавьте бонусные призы: множители выигрыша или обычные призы из кейса
                              </div>
                           </div>
                        </>
                     )}
                  </div>
               )}

               <div className={s.actions}>
                  <button type="submit" className={root.btnPrimary}>Сохранить</button>
                  {error && <div style={{ color: "red" }}>{error}</div>}
                  {ok && <div style={{ color: "green" }}>{ok}</div>}
               </div>
            </form>
         </div>
      </div>
   );
}
